import PerformanceHelper from '../helpers/performance_helper';

// Report page load performance to Gusto Analytics after 5 seconds.
const performanceHelper = new PerformanceHelper();
performanceHelper.executeFunctionOnLoad(function() {
  const data = performanceHelper.getPageLoadInformation();
  if (data && window.GustoAnalytics) {
    // Sends the timing hit to Google Analytics.
    console.debug(`Reporting page load to Gusto Analytics`);
    window.GustoAnalytics.track({
      eventCategory: 'GustoPerformance',
      eventName: 'PageLoad',
      data,
    });
  }
}, null);
